import { render, staticRenderFns } from "./QEmojiPicker.vue?vue&type=template&id=6885e6f4&scoped=true"
import script from "./QEmojiPicker.vue?vue&type=script&lang=js"
export * from "./QEmojiPicker.vue?vue&type=script&lang=js"
import style0 from "./QEmojiPicker.vue?vue&type=style&index=0&id=6885e6f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6885e6f4",
  null
  
)

export default component.exports